/**
 * Codec for SurveyQuestionAnswer.answerValue on Media-type questions.
 * Stores an array of file paths as a JSON-encoded string. Reads support
 * the legacy single-path format so existing answers keep rendering.
 */

const VIDEO_EXTENSIONS = new Set([".mp4", ".mov", ".webm", ".quicktime"]);

export function parsePaths(answerValue: string | undefined | null): string[] {
  if (!answerValue) return [];
  const trimmed = answerValue.trim();
  if (trimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.filter(
          (item): item is string => typeof item === "string" && item.length > 0
        );
      }
    } catch {
      // Fall through to single-path interpretation.
    }
  }
  return [answerValue];
}

export function serializePaths(paths: string[]): string {
  return JSON.stringify(paths);
}

export function isVideoPath(path: string): boolean {
  const lastDot = path.lastIndexOf(".");
  if (lastDot < 0) return false;
  const ext = path.slice(lastDot).toLowerCase();
  return VIDEO_EXTENSIONS.has(ext);
}

export function getFileNameFromPath(path: string): string {
  const lastSlash = path.lastIndexOf("/");
  return lastSlash >= 0 ? path.slice(lastSlash + 1) : path;
}
